<template>
  <AppDialog
    class="members-update-dialog profile-fields-dialog"
    title="Which profile fields would you like to update?"
    append-to-body
    show
    @close="close"
  >
    <div class="d-flex flex-inline-row align-content-center align-items-center description">
      <div class="note">Two CSVs will download</div>
      <div class="ml-auto">
        <!--        TODO: Uncomment when the link is available -->
        <!--        <a class="nav-link">Learn more</a>-->
      </div>
    </div>

    <div class="list">
      <div class="list-item">
        <div class="list-item-body">
          <div class="d-flex align-items-center flex-row gap-4">
            <h4>ReferenceSheet.CSV</h4>
            <h6>(Read-only)</h6>
          </div>
          <div class="d-flex align-items-center mt-5 flex-row">
            <h5>A reference of the requirements and choices for the fields selected below.</h5>
          </div>
        </div>
      </div>
      <div class="list-item">
        <div class="list-item-body">
          <div class="d-flex align-items-center flex-row">
            <h4>ChangeSheet.CSV</h4>
          </div>
          <div class="d-flex align-items-center mt-5 flex-row">
            <h5>
              Be careful to only make edits in columns labeled with ✏️. Changes to columns marked '(read-only)' will be
              ignored when uploaded.
            </h5>
          </div>

          <div
            v-for="{ id, name, tooltips } in membersUpdateProfileFieldsSettings"
            :key="id"
          >
            <div
              :key="id"
              class="checkbox-row"
            >
              <AppCheckbox v-model="sections[id]">
                {{ name }}
                <i
                  v-if="!!tooltips"
                  v-tooltip="{ placement: 'right', html: true, container: '.profile-fields-dialog' }"
                  class="a-tooltip hi hi-12 hi-info-filled text-lighter"
                  :title="tooltips.join('<br/>')"
                />
              </AppCheckbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="d-flex justify-space-between flex-column flex-sm-row align-items-center mt-40 gap-20">
        <a
          class="nav-link"
          :disabled="showFilesLoading"
          @click="goToUpload"
        >
          Skip to upload
        </a>
        <div>
          <AppButton
            class="mr-15"
            type="default"
            @click="close"
          >
            Cancel
          </AppButton>
          <AppButton
            type="primary"
            :disabled="downloadButtonDisabled"
            @click="downloadCSVTemplates"
          >
            {{ showFilesLoading ? 'Downloading...' : 'Download CSV templates' }}
          </AppButton>
        </div>
      </div>
    </div>
  </AppDialog>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'MembersUpdateProfileFieldsDialog',
  data() {
    return {
      sections: {},
    };
  },
  computed: {
    ...mapGetters([
      'organizationId',
      'apiErrors',
      'hasSelectedMembers',
      'membersUpdateProfileFieldsSettings',
      'showSettingsLoading',
      'showFilesLoading',
    ]),
    ...mapState({
      batchActionIds: 'batch_action_ids',
    }),

    valid() {
      return Object.values(this.sections).findIndex((val) => val) > -1;
    },
    downloadButtonDisabled() {
      return !this.valid || !!this.apiErrors?.length || this.showFilesLoading || this.showSettingsLoading;
    },
    selectedIds() {
      return this.hasSelectedMembers ? this.batchActionIds : { all: true, except: [] };
    },
  },
  beforeMount() {
    this.loadMembersUpdateSettings({ organizationId: this.organizationId });
  },
  methods: {
    ...mapActions(['loadMembersUpdateSettings', 'getMembersUpdateCSV']),
    close() {
      this.$emit('close');
    },
    skipToUpload() {
      this.$emit('skipToUpload');
    },
    nextStep() {
      this.$emit('nextStep');
    },
    goToUpload() {
      if (!this.showFilesLoading) {
        this.nextStep();
      }
    },
    async downloadCSVTemplates() {
      await this.getMembersUpdateCSV({
        organizationId: this.organizationId,
        sections: this.sections,
        ids: this.selectedIds,
      });
      this.skipToUpload();
    },
  },
};
</script>
